export default {
    bloglist: {
        en: [
            {
                title: 'Best Auto Reply Messages for Small Business Owners on GB WhatsApp',
                poster: require('@/assets/blog-post-cover.png'),
                desc: 'Looking for professional auto reply messages for GB WhatsApp? Discover ready-to-use templates for small businesses, online stores, service providers, and customer support.',
                name: 'en-auto-reply-messages-for-small-business-owners-gbwhatsapp',
                url: '/auto-reply-messages-for-small-business-owners-gbwhatsapp/',
                date: '2026-06-03',
            },
            {
                title: 'GB WhatsApp Crashing After Update? 7 Fixes That Actually Work',
                poster: require('@/assets/blog-post-cover.png'),
                desc: 'Updated GB WhatsApp and now it keeps crashing? Discover the most common reasons behind the issue and 7 practical fixes that can help restore app stability quickly.',
                name: 'en-gb-whatsapp-crashing-after-update',
                url: '/gb-whatsapp-crashing-after-update/',
                date: '2026-06-03',
            },
            {
                title: 'Should You Update GB WhatsApp? Pros, Cons & Risks Explained',
                poster: require('@/assets/blog-post-cover.png'),
                desc: 'Wondering whether to update GB WhatsApp? Learn the benefits, risks, new features, and why many experienced users wait before installing the latest version.',
                name: 'en-should-you-update-gbwhatsapp',
                url: '/should-you-update-gbwhatsapp/',
                date: '2026-06-03',
            },
            {
                title: 'How to Backup GBWhatsApp Chats to Google Drive',
                poster: require('@/assets/blog-1.webp'),
                desc: "Guide to backing up GBWhatsApp chats to Google Drive. Covers setup, manual and automatic backups, storage management, and restoring data to keep your chats and media safe.",
                name: 'en-backup-gbwhatsapp-chats-to-google-drive',
                url: '/backup-gbwhatsapp-chats-to-google-drive/',
                date: "2025-12-05",
            },
            {
                title: 'GBWhatsApp Banned Problem Fix – Reasons, Solutions, and Prevention Tips',
                poster: require('@/assets/blog-2.webp'),
                desc: "Explore GBWhatsApp banned problem fix, including reasons, solutions, chat backup tips, and prevention strategies to avoid temporary and permanent account bans.",
                name: 'en-gbwhatsapp-banned-problem-fix',
                url: '/gbwhatsapp-banned-problem-fix/',
                date: "2026-03-16",
            },
            {
                title: 'How to Reduce GB WhatsApp Storage Usage (Clear Cache & Free Space 2026)',
                poster: require('@/assets/blog-post-cover.png'),
                desc: "Learn how to reduce GB WhatsApp storage usage on Android. Clear cache, manage media files, and free up space safely without losing important chats or data.",
                name: 'en-how-to-reduce-gb-whatsapp-storage-usage',
                url: '/how-to-reduce-gb-whatsapp-storage-usage/',
                date: "2026-05-13",
            },
            {
                title: 'GB WhatsApp vs Telegram: Full Comparison (Features, Privacy & Performance 2026)',
                poster: require('@/assets/blog-post-cover.png'),
                desc: "Compare GB WhatsApp vs Telegram in detail. Learn differences in privacy, storage, customization, messaging features, and group functions to decide which app is better in 2026.",
                name: 'en-gb-whatsapp-vs-telegram',
                url: '/gb-whatsapp-vs-telegram/',
                date: "2026-05-13",
            },
            {
                title: 'GBWhatsApp vs Official WhatsApp (2026): Features, Privacy & Why Users Switch',
                poster: require('@/assets/blog-2-post-cover.webp'),
                desc: "Compare GBWhatsApp vs Official WhatsApp in 2026. Learn why users choose GBWhatsApp for privacy, customization, and file sharing, plus risks, features, and safety tips.",
                name: 'en-gbwhatsapp-vs-official-whatsapp',
                url: '/gbwhatsapp-vs-official-whatsapp-2026/',
                date: "2026-06-16",
            },
        ],
    }
    
}